module.exports = __webpack_public_path__ + "static/img/design-3.546973dd.png";